import React from 'react';

const Display = ({ weather }) => {
  if (!weather) return <p>No weather data. Please search for a city.</p>;

  return (
    <div className='dis'>
      <img
        src={weather.current.condition.icon}
        alt={weather.current.condition.text}
      />
      <h3>{weather.current.temp_c} °C</h3>
      <h5>{weather.location.name},{weather.location.region}, {weather.location.country}</h5>
      <p>{weather.current.condition.text}</p>
    </div>
  );
};

export default Display;

